// extracted by mini-css-extract-plugin
export default {"drawer":"styles_drawer__vagaA","drawerContent":"styles_drawerContent__KhHJC","bannersContainer":"styles_bannersContainer__FhRKg"};